// src/design-system/NumberedSteps.tsx
export type NumberedStep = { n: string; label: string; who: string; done: boolean };

const GOLD = "#D6AC55";
const GOLD_L = "#F0CE8A";

/** مراحل مرقّمة (طلب الصرف): كرة 28px بالرقم، وخط بعرض الخطوة كاملاً يتوهج ذهبياً عند اكتمال الخطوتين المتجاورتين. */
export function NumberedSteps({ steps }: { steps: NumberedStep[] }) {
  return (
    <ol className="m-0 flex list-none items-start p-0" aria-label="مراحل الطلب">
      {steps.map((s, i) => {
        const linked = i > 0 && steps[i - 1].done && s.done;
        return (
          <li key={s.n} className="relative flex min-w-0 flex-1 flex-col items-center gap-[9px] text-center">
            <div className="absolute inset-x-0 top-[13px] h-0.5"
              style={{ background: i === 0 ? "transparent" : linked ? `linear-gradient(90deg,${GOLD_L},${GOLD})` : "rgba(148,180,214,.18)", boxShadow: linked ? "0 0 10px rgba(214,172,85,.45)" : "none" }} />
            <div className="mono z-[1] flex h-7 w-7 items-center justify-center rounded-full text-xs"
              style={{ background: s.done ? `radial-gradient(circle at 35% 30%,${GOLD_L},rgba(9,24,39,.9))` : "rgba(148,180,214,.10)",
                boxShadow: s.done ? `0 0 18px rgba(214,172,85,.55), 0 0 0 1px ${GOLD}` : "0 0 0 1px rgba(148,180,214,.25)", color: s.done ? "#F5E4C0" : "#8FA3B8" }}>{s.n}</div>
            <strong className="text-[13px]" style={{ fontWeight: s.done ? 600 : 400, color: s.done ? "#F5E4C0" : "#8FA3B8" }}>{s.label}</strong>
            <span className="text-[11.5px] text-muted-2">{s.who}</span>
          </li>
        );
      })}
    </ol>
  );
}
